var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{attrs:{"color":_vm.$variables.v.theme.secondary,"size":"40px"},on:{"click":_vm.confirm_logout}},[_vm._v(" mdi-power ")]),_c('dialog-confirm',{ref:"confirm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }